/**
 * Local Delivery - Pre-checkout Upsell Modal
 * Depends on wf-ld-api.js (window.WF_LD_API.API_BASE)
 */
(function () {
  'use strict';

  var config = null;
  var countdownInterval = null;
  var remainingSeconds = 0;
  var stockMap = {};
  var productTagCache = {};
  var checkoutTransitionActive = false;

  function getApiBase() {
    return (window.WF_LD_API && window.WF_LD_API.API_BASE) || 'https://planners.dand3.com';
  }

  function getStoreKey() {
    if (window.WF_LD_API && typeof window.WF_LD_API.getStoreKey === 'function') {
      return window.WF_LD_API.getStoreKey();
    }
    if (window.WF_LD_RUNTIME && window.WF_LD_RUNTIME.storeKey) {
      return String(window.WF_LD_RUNTIME.storeKey).trim().toUpperCase();
    }
    return 'WF';
  }

  function getDeliveryUrl(pathAndQuery) {
    if (window.WF_LD_API && typeof window.WF_LD_API.buildDeliveryUrl === 'function') {
      return window.WF_LD_API.buildDeliveryUrl(pathAndQuery);
    }
    return getApiBase() + '/api/delivery/' + encodeURIComponent(getStoreKey()) + pathAndQuery;
  }

  function checkStock(products) {
    var handles = {};
    for (var i = 0; i < products.length; i++) {
      if (products[i].handle) handles[products[i].handle] = true;
    }
    var uniqueHandles = Object.keys(handles);
    if (uniqueHandles.length === 0) return Promise.resolve();

    var fetches = uniqueHandles.map(function (h) {
      return fetch('/products/' + h + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (prod) {
          if (!prod || !prod.variants) return;
          for (var j = 0; j < prod.variants.length; j++) {
            var v = prod.variants[j];
            stockMap[String(v.id)] = v.available;
          }
        })
        .catch(function () { /* ignore fetch failures */ });
    });

    return Promise.all(fetches);
  }

  function isInStock(variantId) {
    var vid = numericId(variantId);
    if (!(vid in stockMap)) return true;
    return stockMap[vid];
  }

  function init() {
    return fetch(getDeliveryUrl('/upsell-public?_t=' + Date.now()), { credentials: 'omit', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        config = data;
        console.log('[wf-upsell] config loaded', config && config.enabled, config && config.products && config.products.length);
        if (config && config.enabled && config.products && config.products.length > 0) {
          return checkStock(config.products).then(function () {
            console.log('[wf-upsell] stock checked', stockMap);
            renderProducts(config.products);
          });
        }
        return config;
      })
      .catch(function (err) {
        console.warn('[wf-upsell] Failed to load config', err);
        config = null;
        return null;
      });
  }

  function isEnabled() {
    return config && config.enabled && config.products && config.products.length > 0;
  }

  function normalizeTag(tag) {
    return String(tag || '').trim().toLowerCase();
  }

  function parseProductTags(rawTags) {
    if (Array.isArray(rawTags)) return rawTags.map(normalizeTag).filter(Boolean);
    if (typeof rawTags === 'string') {
      return rawTags.split(',').map(normalizeTag).filter(Boolean);
    }
    return [];
  }

  function fetchProductTagsByHandle(handle) {
    if (!handle) return Promise.resolve([]);
    if (productTagCache[handle]) return Promise.resolve(productTagCache[handle]);
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (product) {
        var tags = parseProductTags(product && product.tags);
        productTagCache[handle] = tags;
        return tags;
      })
      .catch(function () { return []; });
  }

  function getCartProductTags() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items || cart.items.length === 0) return [];
        var uniqueHandles = {};
        for (var i = 0; i < cart.items.length; i++) {
          var handle = cart.items[i].handle;
          if (handle) uniqueHandles[handle] = true;
        }
        var handles = Object.keys(uniqueHandles);
        if (handles.length === 0) return [];
        return Promise.all(handles.map(fetchProductTagsByHandle))
          .then(function (lists) {
            var set = {};
            for (var li = 0; li < lists.length; li++) {
              for (var ti = 0; ti < lists[li].length; ti++) {
                set[lists[li][ti]] = true;
              }
            }
            return Object.keys(set);
          });
      })
      .catch(function () { return []; });
  }

  function matchesRule(cartTags, ruleTags, matchMode) {
    if (!ruleTags || ruleTags.length === 0) return false;
    var tagSet = {};
    for (var i = 0; i < cartTags.length; i++) tagSet[normalizeTag(cartTags[i])] = true;
    if (matchMode === 'all') {
      for (var j = 0; j < ruleTags.length; j++) {
        if (!tagSet[normalizeTag(ruleTags[j])]) return false;
      }
      return true;
    }
    for (var k = 0; k < ruleTags.length; k++) {
      if (tagSet[normalizeTag(ruleTags[k])]) return true;
    }
    return false;
  }

  function shouldShowForCart() {
    if (!isEnabled()) return Promise.resolve(false);
    var showTags = (config.showForProductTags || []).map(normalizeTag).filter(Boolean);
    var hideTags = (config.hideForProductTags || []).map(normalizeTag).filter(Boolean);
    if (showTags.length === 0 && hideTags.length === 0) return Promise.resolve(true);

    var mode = config.tagMatchMode === 'all' ? 'all' : 'any';
    return getCartProductTags().then(function (cartTags) {
      if (hideTags.length > 0 && matchesRule(cartTags, hideTags, mode)) {
        return false;
      }
      if (showTags.length > 0) {
        return matchesRule(cartTags, showTags, mode);
      }
      return true;
    });
  }

  function renderProducts(products) {
    var container = document.getElementById('wf-upsell-products');
    if (!container) return;
    container.innerHTML = '';

    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      var available = isInStock(p.shopifyVariantId);
      var card = document.createElement('div');
      card.className = 'wf-upsell-product' + (available ? '' : ' wf-upsell-product--sold-out');

      var imgHtml = p.imageUrl
        ? '<img src="' + escapeAttr(p.imageUrl) + '" alt="' + escapeAttr(p.title) + '" loading="lazy">'
        : '<div class="wf-upsell-product__placeholder"></div>';

      var btnHtml = available
        ? '<button type="button" class="wf-upsell-product__add" data-variant-id="' + escapeAttr(p.shopifyVariantId) + '">Add</button>'
        : '<button type="button" class="wf-upsell-product__add wf-upsell-product__add--sold-out" disabled>Sold out</button>';

      card.innerHTML =
        imgHtml +
        '<div class="wf-upsell-product__info">' +
          '<p class="wf-upsell-product__name">' + escapeHtml(p.title) + '</p>' +
          '<p class="wf-upsell-product__variant">' + escapeHtml(p.variantTitle) + '</p>' +
        '</div>' +
        '<span class="wf-upsell-product__price">$' + escapeHtml(p.price) + '</span>' +
        btnHtml;

      container.appendChild(card);
    }

    container.querySelectorAll('.wf-upsell-product__add:not(.wf-upsell-product__add--sold-out)').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var vid = btn.getAttribute('data-variant-id');
        addToCart(vid, btn);
      });
    });
  }

  function numericId(raw) {
    var m = String(raw).match(/(\d+)$/);
    return m ? m[1] : raw;
  }

  function addToCart(variantId, btn) {
    btn.disabled = true;
    btn.textContent = 'Adding...';

    var vid = numericId(variantId);
    console.log('[wf-upsell] adding variant', vid);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: vid, quantity: 1 }),
    })
      .then(function (r) {
        if (r.status === 422) {
          btn.textContent = 'Sold out';
          btn.classList.add('wf-upsell-product__add--sold-out');
          stockMap[vid] = false;
          return;
        }
        if (!r.ok) throw new Error('Add failed');
        return r.json();
      })
      .then(function (data) {
        if (data) {
          btn.textContent = 'Added ✓';
          btn.style.opacity = '0.6';
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Add';
      });
  }

  function show(onContinue) {
    if (!isEnabled()) {
      if (typeof onContinue === 'function') onContinue();
      return;
    }

    var overlay = document.getElementById('wf-upsell-overlay');
    var titleEl = document.getElementById('wf-upsell-title');
    var timerEl = document.getElementById('wf-upsell-timer');
    if (!overlay) {
      if (typeof onContinue === 'function') onContinue();
      return;
    }

    resetCheckoutTransitionState();
    if (titleEl) titleEl.textContent = config.title || '';

    overlay.style.display = 'flex';

    if (config.countdownSeconds > 0) {
      remainingSeconds = config.countdownSeconds;
      if (timerEl) {
        timerEl.style.display = '';
        updateTimerDisplay(timerEl);
      }
      countdownInterval = setInterval(function () {
        remainingSeconds--;
        if (timerEl) updateTimerDisplay(timerEl);
        if (remainingSeconds <= 0) {
          closeModal(onContinue);
        }
      }, 1000);
    }

    var declineBtn = document.getElementById('wf-upsell-decline');
    var continueBtn = document.getElementById('wf-upsell-continue');
    var closeBtn = document.getElementById('wf-upsell-close');

    function onDismiss() {
      if (checkoutTransitionActive) return;
      setCheckoutTransitionState();
      if (typeof onContinue === 'function') onContinue();
    }

    if (declineBtn) {
      declineBtn.onclick = onDismiss;
    }
    if (continueBtn) {
      continueBtn.onclick = onDismiss;
    }
    if (closeBtn) {
      closeBtn.onclick = onDismiss;
    }

    overlay.onclick = function (e) {
      if (e.target === overlay) onDismiss();
    };
  }

  function setCheckoutTransitionState(message) {
    var overlay = document.getElementById('wf-upsell-overlay');
    if (!overlay) return;
    checkoutTransitionActive = true;
    if (countdownInterval) {
      clearInterval(countdownInterval);
      countdownInterval = null;
    }

    var titleEl = document.getElementById('wf-upsell-title');
    var timerEl = document.getElementById('wf-upsell-timer');
    var productsEl = document.getElementById('wf-upsell-products');
    var actionsEl = overlay.querySelector('.wf-upsell-actions');
    var closeBtn = document.getElementById('wf-upsell-close');
    var transitionEl = document.getElementById('wf-upsell-transition');
    var transitionMessageEl = document.getElementById('wf-upsell-transition-message');

    overlay.style.display = 'flex';
    if (titleEl) {
      titleEl.textContent = '';
      titleEl.style.display = 'none';
    }
    if (timerEl) timerEl.style.display = 'none';
    if (productsEl) productsEl.style.display = 'none';
    if (actionsEl) actionsEl.style.display = 'none';
    if (closeBtn) closeBtn.style.display = 'none';
    if (transitionMessageEl) {
      transitionMessageEl.textContent = message || 'We are securing your delivery details. Please do not refresh.';
    }
    if (transitionEl) transitionEl.style.display = 'flex';
  }

  function resetCheckoutTransitionState() {
    checkoutTransitionActive = false;
    var overlay = document.getElementById('wf-upsell-overlay');
    if (!overlay) return;

    var timerEl = document.getElementById('wf-upsell-timer');
    var productsEl = document.getElementById('wf-upsell-products');
    var actionsEl = overlay.querySelector('.wf-upsell-actions');
    var closeBtn = document.getElementById('wf-upsell-close');
    var transitionEl = document.getElementById('wf-upsell-transition');
    var titleEl = document.getElementById('wf-upsell-title');

    if (productsEl) productsEl.style.display = '';
    if (actionsEl) actionsEl.style.display = 'flex';
    if (closeBtn) closeBtn.style.display = '';
    if (transitionEl) transitionEl.style.display = 'none';
    if (titleEl) titleEl.style.display = '';
    if (timerEl && config && config.countdownSeconds > 0) timerEl.style.display = '';
  }

  function closeModal(callback) {
    if (countdownInterval) {
      clearInterval(countdownInterval);
      countdownInterval = null;
    }
    var overlay = document.getElementById('wf-upsell-overlay');
    if (overlay) overlay.style.display = 'none';
    resetCheckoutTransitionState();
    if (typeof callback === 'function') callback();
  }

  function updateTimerDisplay(el) {
    var m = Math.floor(remainingSeconds / 60);
    var s = remainingSeconds % 60;
    el.textContent = 'Offer ends in: ' + pad(m) + ':' + pad(s);
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str || ''));
    return div.innerHTML;
  }

  function escapeAttr(str) {
    return (str || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  window.WF_LD_UPSELL = {
    hide: closeModal,
    init: init,
    resetCheckoutTransitionState: resetCheckoutTransitionState,
    setCheckoutTransitionState: setCheckoutTransitionState,
    show: show,
    isEnabled: isEnabled,
    shouldShowForCart: shouldShowForCart,
  };
})();
